package ui.new_ui.components.divider

import emotion.react.css
import helpers.PropsWithCss
import helpers.takeIfNotUndefined
import react.FC
import react.dom.html.ReactHTML
import ui.new_ui.color_scheme.MainColorScheme
import web.cssom.None
import web.cssom.px

external interface DividerHorizontalProps : PropsWithCss

val DividerHorizontal = FC<DividerHorizontalProps> { props->
    val css_ = props.css.takeIfNotUndefined()

    ReactHTML.hr{
        this.css {
            height = 1.px
            border = None.none
            backgroundColor = MainColorScheme.SecondaryColors.secondaryColorOnContainer()
            css_?.let {
                css_(this)
            }
        }
    }
}